<template>
  <AppSubmenu :items="items" class="layout-menu" :root="true" />
  <Dialog
    header="Selecione um cliente"
    v-model:visible="dialogVisible"
    :style="{ width: '35vw' }"
    :modal="true"
    :closable="true"
  >
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12">
        Para acessar esses dados é necessário selecionar um dos seus clientes,
        após isso clique em Aplicar.
      </div>
      <div class="p-field p-col-12">
        <AppFormItem label="Cliente">
          <AppAutoComplete
            v-model="customerId"
            valueField="id"
            :options="customerOptions"
          ></AppAutoComplete>
        </AppFormItem>
      </div>
    </div>
    <template #footer>
      <AppButton
        label="Aplicar"
        class="p-button-primary"
        :loading="loadingSelect"
        @click="selectCustomer()"
      />
    </template>
  </Dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { VetCustomerApi } from '../../services/api';
import AppSubmenu from './AppSubmenu';

export default {
  components: {
    AppSubmenu,
  },
  data() {
    return {
      dialogVisible: false,
      customerId: null,
      customerOptions: [],
      loadingSelect: false,
    };
  },
  computed: {
    ...mapGetters('app', ['vetCustomer', 'permissions']),
    items() {
      return [
        {
          label: this.vetCustomer?.account?.name
            ? this.vetCustomer.account.name
            : 'Selecionar cliente',
          icon: 'app-icon app-icon-connect blue',
          style:
            'color: #244AAE; font-weight: bold; border-top: 1px solid #969696;',
          command: () => this.showCustomerSelect(),
        },
        {
          label: 'Bovinos',
          icon: 'app-icon app-icon-bovine blue',
          style: 'color: #244AAE; padding-left: 40px',
          to: 'bovine.list',
          disabled: !this.vetCustomer,
        },
        {
          label: 'Serviços',
          icon: 'app-icon app-icon-service blue',
          style: 'color: #244AAE; padding-left: 40px',
          to: 'customer-service.list',
          disabled: !this.vetCustomer,
        },
      ];
    },
  },
  methods: {
    ...mapActions('app', ['setVetCustomer']),
    async showCustomerSelect() {
      this.dialogVisible = true;
      const response = await VetCustomerApi.fetch({ order: 'asc', accepted: true });
      const options = response.results.map((result) => ({
        ...result,
        name: result.account.name,
      }));
      this.customerOptions = [...options, { id: null, name: 'Nenhum' }];
    },
    async selectCustomer() {
      try {
        const customer = this.customerOptions.find(
          (option) => option.id === this.customerId
        );
        if (!customer || !customer.id) {
          this.setVetCustomer(null);
          this.dialogVisible = false;
          this.$ability.update(this.permissions);
          return;
        }
        this.loadingSelect = true;
        const loginData = await VetCustomerApi.login({
          accountId: customer.accountId,
        });

        const vetCustomer = {
          ...customer,
          ...loginData,
          apis: ['/bovines', '/services', '/breeds', '/farms', '/owners', '/vets'],
          routes: ['/cliente/servicos', '/bovinos'],
        };

        this.setVetCustomer(vetCustomer);
        this.dialogVisible = false;
        this.$ability.update(this.permissions);
      } finally {
        this.loadingSelect = false;
      }
    },
  },
};
</script>

<style scoped>
</style>
